import { apiFetch } from "@/hooks/apiFetch"

export const fetchCategoriesForNavbar = async (signal?: AbortSignal) =>
  apiFetch(`website/categories`, {
    signal,
  })
